import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import SEOHead from '@/components/base/SEOHead';
import { comics, categories } from '@/mocks/comics';

const siteUrl = 'http://iitzgd.cn/';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || 'romance';
  const category = categories.find((c) => c.slug === activeSlug);
  const categoryComics = comics.filter((c) => c.category === activeSlug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="pt-20 pb-10 text-center">
          <p className="text-foreground-500">分类不存在</p>
        </div>
        <Footer />
      </>
    );
  }

  const pageUrl = `${siteUrl}/category/${activeSlug}`;

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: `${category.name} - 韩漫大全`,
      url: pageUrl,
      description: category.description,
      isPartOf: {
        '@type': 'WebSite',
        name: '韩漫大全',
        url: siteUrl,
      },
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: category.name, item: pageUrl },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title={`${category.name}韩国漫画_${category.name}韩漫推荐_韩漫大全`}
        description={category.description}
        keywords={`${category.name},韩国漫画,韩漫,${category.name}韩漫,免费漫画`}
        canonicalUrl={pageUrl}
        schemaData={schema}
      />
      <Navbar />
      <main>
        <div className="pt-16">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: category.name }]} />

          <section className="relative h-[200px] md:h-[280px] bg-foreground-900 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 to-foreground-950/40"></div>
            <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
              <h1 className="font-heading text-2xl md:text-4xl text-background-50 mb-3">{category.name}</h1>
              <p className="text-sm text-background-300 max-w-md">{category.description}</p>
              <p className="text-xs text-background-500 mt-2">共 {category.count.toLocaleString()} 部作品</p>
            </div>
          </section>

          <div className="sticky top-16 z-20 bg-background-50 border-b border-background-200">
            <div className="mx-auto px-4 md:px-6 flex items-center gap-1 overflow-x-auto py-2 scrollbar-hide">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    cat.slug === activeSlug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="mx-auto px-4 md:px-6">
              {categoryComics.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                  {categoryComics.map((comic) => (
                    <ComicCard
                      key={comic.id}
                      {...comic}
                      variant="default"
                      coverImage={comic.coverImage}
                      coverImageLarge={comic.coverImageLarge}
                    />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <i className="ri-emotion-sad-line text-4xl text-foreground-300 mb-4 block"></i>
                  <p className="text-foreground-500">该分类暂无漫画</p>
                </div>
              )}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
